import { PersonJobType } from '@api';
import { UseManageTableReturnType } from '@common';
import { TourRepSelfPromote } from '@features';

type PersonDetailsTourRepPagePropsType = {
  personId: string;
  unconfirmedShows: PersonJobType[];
  upcomingShows: PersonJobType[];
  previousShows: PersonJobType[];
  isPendingUnconfirmedShows: boolean;
  isPendingUpcomingShows: boolean;
  isPendingPreviousShows: boolean;
  upcomingTableMethods: UseManageTableReturnType;
  previousTableMethods: UseManageTableReturnType;
};

export const PersonDetailsTourRepPage: React.FC<
  PersonDetailsTourRepPagePropsType
> = ({
  personId,
  unconfirmedShows,
  upcomingShows,
  previousShows,
  isPendingUnconfirmedShows,
  isPendingUpcomingShows,
  isPendingPreviousShows,
  upcomingTableMethods,
  previousTableMethods,
}) => {
  return (
    <TourRepSelfPromote
      personId={personId}
      unconfirmedShows={unconfirmedShows}
      upcomingShows={upcomingShows}
      previousShows={previousShows}
      isPendingUnconfirmedShows={isPendingUnconfirmedShows}
      isPendingUpcomingShows={isPendingUpcomingShows}
      isPendingPreviousShows={isPendingPreviousShows}
      upcomingTableMethods={upcomingTableMethods}
      previousTableMethods={previousTableMethods}
    />
  );
};
